import * as Sentry from '@sentry/browser';

import { isManagedServiceSubscription } from 'utils/subscription';

import type {
  Organization,
  RuntimeConfig
} from 'types';

export const hasProductListPage = (
  currentOrganization?: Organization | null,
  campaignProductListAccessIds?: RuntimeConfig['campaignProductListAccessIds']
): boolean => {
  try {
    return (
      Boolean(currentOrganization)
      && (
        isManagedServiceSubscription(currentOrganization ?? null)
        || (
          (campaignProductListAccessIds ?? '')
            .split(',')
            .map(v => parseInt(v.trim(), 10))
            .includes(currentOrganization?.id ?? -1)
        ))
    );
  } catch (e) {
    Sentry.captureException(new Error(`Error occurred while resolving hasProductListPage with campaignProductListAccessIds: ${campaignProductListAccessIds}: ${e}`));

    return false;
  }
};
